module.exports = __webpack_public_path__ + "img/symbol_9.c68310e5.png";